<template>
  <div>
    <Form ref="formInline" inline :label-width="120" label-position="left">
      <Row type="flex" justify="space-between">
        <Col span="20">
          <FormItem label="用户组名：">
            <Input
              v-model="otCtrl.groupName"
              style="width: 300px;margin-right:30px"
            />
          </FormItem>
          <FormItem label="用户组描述：">
            <Input
              v-model="otCtrl.groupText"
              style="width: 300px;margin-right:30px"
            />
          </FormItem>
          <Button @click="(pageInfo.pageNo = 1), (total = 0), getData()"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
        </Col>
        <Col>
          <Button type="primary" icon="md-add" @click="addData()">新增</Button>
        </Col>
      </Row>
    </Form>
    <Form>
      <Table
        stripe
        border
        :columns="columns"
        :loading="loading"
        :data="dataTable"
      >
        <template slot="slot1" slot-scope="{ row }">
          <Button
            type="warning"
            size="small"
            :disabled="row.beSpFunction == '1'"
            @click="setPop(row)"
            >分配</Button
          >
        </template>
        <template slot="slot" slot-scope="{ row }">
          <Button type="warning" size="small" @click="openPop(row)"
            >编辑</Button
          >
          <Button type="error" size="small" @click="deleteInfo(row)"
            >删除</Button
          >
        </template>
      </Table>
      <Page
        :total="total"
        style="float: left; margin-top: 15px"
        @on-change="pageChange"
      />
    </Form>
    <Modal
      v-model="popShow"
      width="600"
      :title="itemTitle == 1 ? '新增' : '编辑'"
    >
      <Form
        :model="formItem"
        :rules="rules"
        ref="formItem"
        :label-width="185"
        label-position="left"
        style="margin: 10px 40px 0 40px"
      >
        <FormItem label="用户组名：">
          <Input v-model="formItem.groupName" />
        </FormItem>
        <FormItem label="用户组描述：">
          <Input v-model="formItem.groupText" />
        </FormItem>
        <FormItem label="是否调用视图：">
          <Checkbox
            true-value="1"
            false-value="0"
            v-model="formItem.beSpFunction"
            @on-change="getbeSpfunction"
          ></Checkbox>
        </FormItem>
        <FormItem
          label="视图描述："
          v-if="showCheck"
          :prop="formItem.beSpFunction == '1' ? 'spFunctionText' : ''"
        >
          <Input v-model="formItem.spFunctionText" :disabled="beDisabled" />
        </FormItem>
      </Form>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <div slot="footer">
        <Button @click="cancelLeaveData">取消</Button>
        <Button @click="saveLeaveData">保存</Button>
      </div>
    </Modal>
    <Modal v-model="showAdd" width="740" footer-hide>
      <p class="addtitle">用户分配</p>
      <div style="margin:20px 0 20px 20px;">
        <Transfer
          :data="data1"
          :target-keys="targetKeys1"
          :titles="['全部角色', '已选择角色']"
          :render-format="render1"
          @on-change="handleChange1"
          filterable
          :list-style="listStyle"
        ></Transfer>
      </div>
      <div style="display: flex; justify-content: center;">
        <Button @click="saveData">保存</Button>
      </div>
      <Spin size="large" fix v-if="Loading"></Spin>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      total: 0,
      itemTitle: 0,
      spinShow: false,
      loading: false,
      Loading: false,
      dataTable: [],
      otCtrl: {},
      otTypeList: [],
      popShow: false,
      formItem: {
        match_emp_type1: []
      },
      RoleItem: {},
      columns: [
        // {
        //   title: "用户组ID",
        //   key: "groupId",
        //   align: "center",
        // },
        {
          title: "用户组名",
          key: "groupName",
          align: "center",
          minWidth: 300
        },
        {
          title: "用户组描述",
          key: "groupText",
          align: "center",
          minWidth: 300
        },
        {
          title: "是否调用视图",
          key: "beSpFunction",
          align: "center",
          minWidth: 250,
          render: (h, params) => {
            return h("span", params.row.beSpFunction == "0" ? "否" : "是");
          }
        },
        {
          title: "视图描述",
          key: "spFunctionText",
          align: "center",
          minWidth: 400
        },
        {
          title: "用户分配",
          align: "center",
          slot: "slot1",
          minWidth: 180
        },

        {
          title: "操作",
          align: "center",
          slot: "slot",
          minWidth: 200
        }
      ],
      showAdd: false,
      departmentList: [],
      formInline: {},
      data1: [],
      targetKeys1: [],
      unitTitles: [],
      row: null,
      listStyle: {
        width: "300px",
        height: "300px"
      },
      beDisabled: false,
      rules: {
        spFunctionText: [{ required: true, message: "请填写存储过程描述" }]
      },
      showCheck: true
    };
  },
  created() {
    this.getData();
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    getbeSpfunction(val) {
      console.log(val);
      if (val == 0) {
        this.beDisabled = true;
        this.$set(this.formItem, "spFunctionText", "");
        this.$refs.formItem.resetFields();
      } else {
        this.beDisabled = false;
      }
      this.checkDom();
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    getData() {
      this.loading = true;
      let obj = {
        groupName: this.otCtrl.groupName,
        groupText: this.otCtrl.groupText,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      axios.post("/MUserGroupMaster/selectMUserGroupMaster", obj).then(res => {
        this.loading = false;
        if (res) {
          this.dataTable = res.data;
          this.total = Number(res.pageInfo.total);
        }
      });
    },
    setPop(row) {
      this.showAdd = true;
      this.row = row;
      this.search();
    },
    openPop(row) {
      this.itemTitle = 0;
      this.popShow = true;
      this.formItem = JSON.parse(JSON.stringify(row));
      if (this.formItem.beSpFunction == 0) {
        this.beDisabled = true;
        this.$refs.formItem.resetFields();
      } else {
        this.beDisabled = false;
      }
      this.$refs.formItem.resetFields();
    },
    addData() {
      this.formItem = {
        beSpFunction: "0"
      };
      this.itemTitle = 1;
      this.popShow = true;
    },
    saveLeaveData() {
      this.$refs["formItem"].validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title: this.$notice("sureSave"),
            onOk: () => {
              this.submitSave();
            }
          });
        } else {
          this.$Message.error("请填写存储过程描述！");
        }
      });
    },
    submitSave() {
      // 新增
      if (this.itemTitle == 1) {
        let obj = {
          ...this.formItem,
          createUser: JSON.parse(sessionStorage.getItem("userInfo")).userId
        };
        axios
          .post("/MUserGroupMaster/insertMUserGroupMaster", obj)
          .then(res => {
            if (res) {
              this.popShow = false;
              this.$Message.success("新增成功");
              this.getData();
            }
          });
      } else {
        //编辑
        let obj = {
          ...this.formItem,
          updateUser: JSON.parse(sessionStorage.getItem("userInfo")).userId
        };
        axios
          .post("/MUserGroupMaster/updateMUserGroupMaster", obj)
          .then(res => {
            if (res) {
              this.popShow = false;
              this.$Message.success("修改成功");
              this.getData();
            }
          });
      }
    },
    cancelLeaveData() {
      this.popShow = false;
    },
    deleteInfo(row) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        onOk: () => {
          let obj = {
            groupId: row.groupId
          };
          axios
            .post("/MUserGroupMaster/deleteMUserGroupMaster", obj)
            .then(res => {
              if (res) {
                this.$Message.success("删除成功");
                this.getData();
              }
            });
        }
      });
    },
    search() {
      let obj = {
        groupId: this.row.groupId
      };
      this.Loading = true;
      axios
        .post("/MUserGroupMaster/selectMUserGroupMasterUser", obj)
        .then(res => {
          if (res) {
            let left = [];
            this.targetKeys1 = [];
            res.forEach((item, index) => {
              left.push({
                ...item,
                key: item.serialnumber,
                label: item.userName
              });
              if (item.beExistence == "1") {
                this.targetKeys1.push(item.serialnumber);
              }
            });
            this.data1 = left;
          }
          this.Loading = false;
        });
    },
    render1(item) {
      return item.label;
    },
    handleChange1(newTargetKeys, direction) {
      let target = [];
      this.data1.forEach((res, index) => {
        newTargetKeys.forEach(element => {
          if (res.serialnumber == element) {
            target.push(this.data1[index].key);
          }
        });
      });
      if (direction == "left") {
        this.targetKeys1 = newTargetKeys;
      } else {
        this.targetKeys1 = this.targetKeys1
          .concat(target)
          .filter((item, index) => {
            return this.targetKeys1.concat(target).indexOf(item) === index;
          });
      }
    },
    saveData() {
      this.Loading = true;
      let arr = [];
      this.targetKeys1.forEach(item => {
        arr.push({ serialnumber: item });
      });
      let obj = {
        groupId: this.row.groupId,
        groupName: this.row.groupName,
        groupText: this.row.groupText,
        createUser: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        listData1: arr
      };
      axios
        .post("/MUserGroupMaster/saveMUserGroupMasterUser", obj)
        .then(res => {
          if (res) {
            this.$Message.success(this.$t("Save_Successful"));
            this.Loading = false;
          }
        });
    },
    checkDom() {
      this.showCheck = false;
      this.$nextTick(() => {
        this.showCheck = true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.addButton {
  text-align: right;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/OrganizationMaintenance/RoleMaintenance.vue